<template>
  <div class="bee-page-wrapper">
    <ul :style="styles" :class="wrapClasses">
      <span :class="[prefixCls + '-total']" v-if="showTotal">
            <slot> 共{{total}}条<!--{{('i.page.total')}}
              <template v-if="total <= 1">{{('i.page.item')}}</template>
              <template v-else>{{('i.page.items')}}</template>-->
            </slot>
      </span>
      <!--:title="('i.page.prev')"-->
      <li
        :class="prevClasses"
        @click="prev">
        <a>
          <template v-if="prevText !== ''">{{prevText}}</template>
          <i v-else class="bee-icon bee-icon-left"></i>
          <!--<i v-else class="bee-icon bee-icon-arrow-back">&lt;</i>-->
        </a>
      </li>
      <li title="1" :class="firstPageClasses" @click="changePage(1)">
        <a>1</a>
      </li>
      <!--:title="('i.page.prev5')"-->
      <li v-if="currentPage > 5"
          :class="[prefixCls + '-item-jump-prev']" @click="fastPrev">
        <a><i class="ivu-icon ivu-icon-arrow-back">&lt;</i></a>
        <!--<a><i class="ivu-icon ivu-icon-arrow-back">&lt;</i></a>-->
      </li>
      <li :title="currentPage - 3" v-if="currentPage === 5" :class="[prefixCls + '-item']" @click="changePage(currentPage - 3)"><a>{{currentPage - 3}}</a></li>
      <li :title="currentPage - 2" v-if="currentPage - 2 > 1" :class="[prefixCls + '-item']" @click="changePage(currentPage - 2)"><a>{{currentPage - 2}}</a></li>
      <li :title="currentPage - 1" v-if="currentPage - 1 > 1" :class="[prefixCls + '-item']" @click="changePage(currentPage - 1)"><a>{{currentPage - 1}}</a></li>
      <li :title="currentPage" v-if="currentPage !== 1 && currentPage !== allPages" :class="[prefixCls + '-item',prefixCls + '-item-active']"><a>{{currentPage}}</a></li>
      <li :title="currentPage + 1" v-if="currentPage + 1 < allPages" :class="[prefixCls + '-item']" @click="changePage(currentPage + 1)"><a>{{currentPage + 1}}</a></li>
      <li :title="currentPage + 2" v-if="currentPage + 2 < allPages" :class="[prefixCls + '-item']" @click="changePage(currentPage + 2)"><a>{{currentPage + 2}}</a></li>
      <li :title="currentPage + 3" v-if="allPages - currentPage === 4" :class="[prefixCls + '-item']" @click="changePage(currentPage + 3)"><a>{{currentPage + 3}}</a></li>
      <li v-if="allPages - currentPage >= 5" :class="[prefixCls + '-item-jump-next']" @click="fastNext">
        <a><i class="been-icon been-icon-arrow-forward">&gt;</i></a>
        <!--<a><i class="been-icon been-icon-arrow-forward">&gt;</i></a>-->
      </li>
      <li :title="allPages" v-if="allPages > 1" :class="lastPageClasses" @click="changePage(allPages)"><a>{{ allPages }}</a></li>
      <!--:title="('i.page.next5')" :title="('i.page.next')"-->
      <li
        :class="nextClasses"
        @click="next">
        <a><template v-if="nextText !== ''">{{ nextText }}</template>
          <!--<i v-else class="been-icon been-icon-arrow-forward"></i>-->
          <i v-else class="bee-icon bee-icon-right"></i></a>
      </li>
      <Options
        :show-sizer="showSizer"
        :page-size="currentPageSize"
        :show-elevator="showElevator"
        :current="currentPage"
        :all-pages="allPages"
        @on-size="onSize"
        @on-page="onPage"
      >
      </Options>
    </ul>
  </div>
</template>

<script>
// import {oneOf} from '../../utils/assist'
import Options from './options.vue'

const prefixCls = 'bee-page'

export default {
  name: 'BeePage',
  props: {
    current: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    showTotal: {
      type: Boolean,
      default: false
    },
    showElevator: {
      type: Boolean,
      default: false
    },
    showSizer: {
      type: Boolean,
      default: false
    },
    className: {
      type: String
    },
    styles: {
      type: Object
    },
    prevText: {
      type: String,
      default: ''
    },
    nextText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      prefixCls: prefixCls,
      currentPage: this.current,
      currentPageSize: this.pageSize
    }
  },
  computed: {
    allPages() {
      const allPage = Math.ceil(this.total / this.currentPageSize)
      return (allPage === 0) ? 1 : allPage
    },
    wrapClasses() {
      return [
        `${prefixCls}`,
        {
          [`${this.className}`]: !!this.className
          /* 'mini': !!this.size */
        }
      ]
    },
    prevClasses() {
      return [
        `${prefixCls}-prev`,
        {
          [`${prefixCls}-disabled`]: this.currentPage === 1,
          [`${prefixCls}-custom-text`]: this.prevText !== ''
        }
      ]
    },
    nextClasses() {
      return [
        `${prefixCls}-next`,
        {
          [`${prefixCls}-disabled`]: this.currentPage === this.allPages,
          [`${prefixCls}-custom-text`]: this.nextText !== ''
        }
      ]
    },
    firstPageClasses() {
      return [
        `${prefixCls}-item`,
        {
          [`${prefixCls}-item-active`]: this.currentPage === 1
        }
      ]
    },
    lastPageClasses() {
      return [
        `${prefixCls}-item`,
        {
          [`${prefixCls}-item-active`]: this.currentPage === this.allPages
        }
      ]
    }
  },
  components: {
    Options
  },
  watch: {
    total(val) {
      let maxPage = Math.ceil(val / this.currentPageSize)
      if(maxPage < this.currentPage) {
        this.currentPage = (maxPage === 0 ? 1 : maxPage)
      }
    },
    current(val) {
      this.currentPage = val
    },
    pageSize(val) {
      this.currentPageSize = val
    }
  },
  methods: {
    changePage(page) {
      if(this.currentPage !== page) {
        this.currentPage = page
        this.$emit('update:current', page)
        this.$emit('on-change', page)
      }
    },
    prev() {
      const current = this.currentPage
      if(current <= 1) {
        return false
      }
      this.changePage(current - 1)
    },
    next() {
      const current = this.currentPage
      if(current >= this.allPages) {
        return false
      }
      this.changePage(current + 1)
    },
    fastPrev() {
      const page = this.currentPage - 3
      if(page > 0) {
        this.changePage(page)
      } else {
        this.changePage(1)
      }
    },
    fastNext() {
      const page = this.currentPage + 3
      if(page > this.allPages) {
        this.changePage(this.allPages)
      } else {
        this.changePage(page)
      }
    },
    onSize(pageSize) {
      this.currentPageSize = pageSize
      this.$emit('on-page-size-change', pageSize)
      this.changePage(1)
    },
    onPage(page) {
      this.changePage(page)
    }
  }
}
</script>
<style lang="scss" scoped>
  .bee-page-wrapper {
    li {
      list-style: none;
      float: left;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/page/page.vue